import { gql } from '@apollo/client'

export default gql`
  query getConsultantTypesForMember($memberId: ID!) {
    consultantTypes(memberId: $memberId)
  }
`
